<div class="text-center">
	<i class="fas fa-circle"
		 [ngClass]="{'active': cellValue, 'inactive': !cellValue}">
	</i>
</div>
